module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return (_vm.blockTypes && _vm.blockTypes.length > 0) ? _h('div', {
    staticClass: "bb8-controls"
  }, [_h('a', {
    class: ['bb8-controls-toggle', {
      'is-active': _vm.showControls
    }],
    attrs: {
      "role": "button",
      "tabindex": "0"
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.toggleControls()
      },
      "click": function($event) {
        _vm.toggleControls()
      }
    }
  }, [_h('svg', {
    staticClass: "icon icon-add-block"
  }, [_h('use', {
    attrs: {
      "xlink:href": "#icon-add-block"
    }
  })])]), " ", (_vm.showControls) ? _h('ul', {
    staticClass: "bb8-controls-block-types"
  }, [_vm._l((_vm.blockTypes), function(blockType) {
    return _h('li', {
      staticClass: "bb8-controls-item"
    }, [_h('a', {
      staticClass: "bb8-controls-action",
      attrs: {
        "role": "button",
        "tabindex": "0"
      },
      on: {
        "keyup": function($event) {
          if (_vm._k($event.keyCode, "enter", 13)) { return; }
          _vm.addBlock(blockType)
        },
        "click": function($event) {
          _vm.addBlock(blockType)
        }
      }
    }, [_h('svg', {
      class: 'icon icon-' + blockType + '-block'
    }, [_h('use', {
      attrs: {
        "xlink:href": '#icon-' + blockType + '-block'
      }
    })])])])
  })]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b4a3d026!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Controls.vue
// module id = 48
// module chunks = 0